import Vue from 'vue';
import store from './store';
import router from './router/';
import App from './App.vue';
import './plugins/element.js';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

const favicon = process.env.VUE_APP_FAVICON || 'favicon.ico';
// Удаляем старую (если есть)
const existingFavicon = document.querySelector('link[rel="icon"]');
if (existingFavicon) {
  existingFavicon.parentNode.removeChild(existingFavicon);
}

// Создаём новую
const link = document.createElement('link');
link.rel = 'icon';
link.href = `/${favicon}`;
document.head.appendChild(link);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
